import {
  CLEAR_MARIGRAM_INFO,
  GET_MARIGRAM_INFO_REFERENCES_REQUEST,
  GET_MARIGRAM_INFO_REQUEST,
  MARIGRAM_INFO_REFERENCE_SORT,
  MARIGRAM_INFO_TOGGLE_COLUMN,
} from './marigramInfoReducer';

export const clearMarigramInfo = () => ({ type: CLEAR_MARIGRAM_INFO });
export const getMarigramInfo = ({ id, history }) => ({ type: GET_MARIGRAM_INFO_REQUEST, id, history });
export const getMarigramReferences = ({ id, history }) => ({ type: GET_MARIGRAM_INFO_REFERENCES_REQUEST, id, history });
export const sortReferences = sort => ({ type: MARIGRAM_INFO_REFERENCE_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: MARIGRAM_INFO_TOGGLE_COLUMN, visibleColumns });
